import {StyleSheet} from 'react-native';
import { Colors } from '../../../constants/Colors';

export const styles = StyleSheet.create({
  container: {
    width: '100%',
    maxWidth: 500,
    alignSelf: 'center',
    backgroundColor: 'white',
    borderRadius: 8,
    paddingHorizontal: 30,
    paddingVertical: 30,
    justifyContent: 'flex-start',
  },
  imageBackground: {flex: 1, paddingHorizontal: 15, justifyContent: 'center', 
    backgroundColor: '#e61c2b'},
  title: {
    fontSize: 22,
    fontFamily: 'TCCC-UnityText Bold',
    lineHeight: 26,
    textAlign: 'center',
    color: 'black',
    marginTop: 20
  },
  description: {
    fontSize: 16,
    fontFamily: 'TCCC-UnityHeadline Regular',
    lineHeight: 20,
    color: 'gray',
    textAlign: 'center',
    maxWidth: 250,
    alignSelf: 'center',
    marginTop: 20,
  },
  containerTextBox: {
    width: 45,
    height: 45,
    borderRadius: 2,
    borderWidth: 1,
    borderColor: 'lightgray',
    justifyContent: 'center',
    alignItems: 'center',
    color: Colors.GrayPallete.lightgrayThree,
    textAlign: 'center',
  },
  containerBox: {
    flexDirection: 'row',
    alignItems: 'center',
    width: '100%',
    justifyContent: 'space-between',
    marginVertical: 50,
  },
  arrowButton: {position: 'absolute', left: 40, top: 40, height: 30, width: 30}
});
